
import React from 'react';

type TInputFieldProps = {
  label: string;
  name: string;
  value: string | number;
  type: string;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  error?: string;
  required?: boolean;
}

export const InputField: React.FC<TInputFieldProps> = ({ label, name, value, type, onChange, error, required }) => (
  <div className="form-group">
    <label htmlFor={name}>{label}{required && '*'}</label>
    <input
      type={type}
      id={name}
      name={name}
      value={value}
      onChange={onChange}
      className={`form-control ${error ? 'is-invalid' : ''}`}
      min={type === 'number' ? 0 : undefined}
    />
    {error && <div className="invalid-feedback">{error}</div>}
  </div>
);
